// Entry point — registering the root component triggers the import chain
// for routes, pages and shared components.
//
// We also kick off the Firebase Auth loader without awaiting it so the
// session resolves in parallel with the rest of the app boot.
// `getFirebaseAuth()` is memoised, so the later `await` inside the shell
// gate (<deck-app>) and the API client hit the same in-flight promise.
import { getFirebaseAuth } from './lib/firebase';
void getFirebaseAuth();

import './app';
